import { useEffect } from 'react';

const useOuterClick = (
    ref: React.MutableRefObject<HTMLInputElement | HTMLDivElement>,
    callback: () => void,
    eventType = 'mousedown'
): void => {
    useEffect(() => {
        function handleClickOutside(event: any) {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        }
        document.addEventListener(eventType, handleClickOutside);
        return () => {
            document.removeEventListener(eventType, handleClickOutside);
        };
    }, [ref, callback, eventType]);
};

export default useOuterClick;
